export { default as DiscordIcon } from "./discord";
export { default as GitHubIcon } from "./github";
export { default as MediumIcon } from "./medium";
export { default as TelegramIcon } from "./telegram";
export { default as TwitterIcon } from "./twitter";
